var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EasyPlayer',{attrs:{"videoUrl":_vm.flvUrl,"aspect":_vm.aspect,"live":_vm.live,"fluent":_vm.fluent,"autoplay":_vm.autoplay,"stretch":""}})}
var staticRenderFns = []

export { render, staticRenderFns }